<template>
  <div v-if="showIndicator" class="environment-indicator" :class="environmentClass">
    <span class="indicator-dot"></span>
    <span class="environment-text">{{ environment }}</span>
    <span class="database-info">{{ databaseInfo }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { config } from '../supabase.js';

const props = defineProps({
  show: {
    type: Boolean,
    default: true
  }
});

const environment = computed(() => config.environment);
const databaseInfo = computed(() => {
  const url = config.supabaseUrl;
  if (url.includes('127.0.0.1') || url.includes('localhost')) {
    return 'Local DB';
  }
  return 'Production DB';
});

const environmentClass = computed(() => `env-${environment.value}`);
const showIndicator = computed(() => props.show && environment.value === 'development');
</script>

<style scoped>
.environment-indicator {
  position: fixed;
  top: 1.5rem;
  right: 10rem;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  backdrop-filter: blur(0.5rem);
}

.indicator-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #10b981;
  animation: pulse 2s infinite;
}

.env-production .indicator-dot {
  background: #ef4444;
}

.env-development .indicator-dot {
  background: #10b981;
}

.environment-text {
  text-transform: uppercase;
  font-weight: 600;
}

.database-info {
  opacity: 0.8;
  font-size: 0.75rem;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>

